import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import router from './router';
import store from './store';
import VueGtag from 'vue-gtag';

Vue.config.productionTip = false;

Vue.use(
  VueGtag,
  {
    config: { id: 'G-QBCT1YECTM' },
  },
  router,
);

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
